import type { FaireProductEntity } from "../../entity_types/product";

export const p_mcstft86q7: FaireProductEntity = {
  token: "p_mcstft86q7",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Solstice",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/e5ba4e99175bb237dce5299324ec3c39d31ddb7b87eff6eae7e492aaea6d2dc1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/974b72c730cecf9db1c251713dbc781a7a9c5ff535a04e66d7ed475ba322d15f.jpeg",
    "https://cdn.faire.com/fastly/146369561e36bcd8942757e65712a8ee1c170ba8cc8aacafe236c327dd71d705.jpeg",
    "https://cdn.faire.com/fastly/d1520923acf59bfeb75afd9b6723516104b0f1289ef0e761a5a151bd16323cc9.jpeg",
    "https://cdn.faire.com/fastly/52b1cdc6378703e52e39356df11e41674c3f4efe736b6c0c6040305b749836c0.jpeg",
    "https://cdn.faire.com/fastly/29b4ddd7f75973ba463099cd090cbb30bdb272bf4a3dc24d41fd76154251aaa8.jpeg",
    "https://cdn.faire.com/fastly/68f80d31b14354e74f20aa1f8073cceb2c5a96adb34add1ad4c417a5d9495172.jpeg",
    "https://cdn.faire.com/fastly/954eb262808ca66e4c27cdebcaa4d24ba56fcc72174f2dc4097d4a52c4337852.jpeg",
    "https://cdn.faire.com/fastly/e4ebd159f92fb47bcb36cb67fada068553ab38692e49a3f642cbcf1c80a9e0b1.jpeg",
    "https://cdn.faire.com/fastly/c4c8ddf1bda03c4ae19526a5702d5c61a23b2de691f1ae1b758930ea30172791.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:21.707Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
